// Browser-storage keys related to Form.io, without importing Form.io itself, so code that runs on
// every page (e.g. logout in useAuth) doesn't pull the Form.io library into the main bundle.

// localStorage key the previous browser-side Form.io login wrote.
export const FORMIO_TOKEN_BASE_URL_KEY = 'formioTokenBaseUrl';

// Where Form.io keeps its token and user (default namespace "formio"): localStorage, or
// sessionStorage when Form.io runs in session mode. Same keys Formio.setToken(null) clears.
const FORMIO_STORAGE_KEYS = ['formioToken', 'formioUser'];

// Removes any Form.io token/user an older version of the app stored in this browser (the browser
// no longer logs in to Form.io: the backend does, with its own service account).
export const clearStoredFormioToken = () => {
  try {
    FORMIO_STORAGE_KEYS.forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
    localStorage.removeItem(FORMIO_TOKEN_BASE_URL_KEY);
  } catch {
    // Storage can be unavailable (e.g. private mode); nothing to clear then.
  }
};
